<template>
  <main class="purchase-order-container">
    <h1
      v-if="showOrder"
      class="title is-size-4 is-marginless"
    >
      {{ $t('purchaseOrder') }}
    </h1>
    <section
      v-if="showOrder"
      class="purchase-order"
    >
      <div
        v-for="(row, index) in orderLayout"
        :key="index"
        class="columns"
      >
        <div
          v-for="(column, index) in row"
          :key="index"
          class="column"
        >
          <order-cell
            v-for="item in column"
            :key="item"
            :item="orderFields[item]"
            :data="orderData[item] || null"
            :can-save-local="!isGenericUser"
            :can-edit="true"
          />
        </div>
      </div>
      <div class="items">
        <label class="label">{{ $tc('part', 2) }}</label>
        <cart-table-review />
      </div>
      <order-attachments  :can-edit="true"
                          :can-add="true"/>
    </section>
    <section
      v-else
      class="purchase-order-loading"
    >
      <loading-icon />
    </section>
    <nav
      v-if="orderLoaded && orderLayout.length"
      class="level is-mobile"
    >
      <div class="level-left">
        <div class="level-item">
          <button
            class="button is-primary"
            :disabled="!canSubmitOrder"
            @click="submitOrder({ type: 'order' })"
          >
            {{ $t('submit') }}
          </button>
          <button
            class="button cancel-button"
            @click="navigateToCart"
          >
            {{ $t('cancel') }}
          </button>
        </div>
        <div
          v-if="canShowTotalRetail"
          class="level-item"
        >
          <h1 class="subtitle">
            {{ $t('retailTotal') }}: {{ cartRetailTotal }}
          </h1>
        </div>
        <div
          v-if="canShowTotalWholesalePrice"
          class="level-item"
        >
          <h1 class="subtitle">
            {{ $t('wholesaleTotal') }}: {{ cartWholesaleTotal }}
          </h1>
        </div>
        <div
          v-if="canShowTotalDiscountedPrice"
          class="level-item"
        >
          <h1 class="subtitle">
            {{ $t('discountedTotal') }}: {{ cartDiscountedTotal }}
          </h1>
        </div>
      </div>
    </nav>
  </main>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import CartTableReview from '@/components/library/cart/orders/CartTableReview'
import LoadingIcon from '@/components/common/LoadingIcon'
import OrderCell from '@/components/library/orders/cells/OrderCell'
import OrderAttachments from '../../orders/attachments/OrderAttachments.vue'

export default {
  name: 'PurchaseOrder',
  components: {
    CartTableReview,
    LoadingIcon,
    OrderCell,
    OrderAttachments
  },
  computed: {
    ...mapGetters({
      isGenericUser: 'user/isGenericUser',
      canSubmitOrder: 'order/canSubmitOrder',
      showOrder: 'order/hasOrderAndNotUpdating'
    }),
    ...mapState({
      cartDiscountedTotal: (state) => state.cart.totalDiscountedPrice,
      cartRetailTotal: (state) => state.cart.totalRetailPrice,
      cartWholesaleTotal: (state) => state.cart.totalWholesalePrice,
      columns: (state) => state.order.partColumns,
      orderData: (state) => state.order.data,
      orderFields: (state) => state.order.fields,
      orderLayout: (state) => state.order.layout,
      orderLoaded: (state) => state.order.isLoaded
    }),
    canShowTotalRetail () {
      return this.columns.some((c) => c.property === 'totalRetailPrice')
    },
    canShowTotalDiscountedPrice () {
      return this.columns.some((c) => c.property === 'totalDiscountedPrice')
    },
    canShowTotalWholesalePrice () {
      return this.columns.some((c) => c.property === 'totalWholesalePrice')
    }
  },
  methods: {
    ...mapActions({
      navigateToCart: 'order/navigateToCart',
      submitOrder: 'order/submitOrder'
    })
  },
  created () {
    this.$store.dispatch('user/initializePricingVisibility')
    this.$store.dispatch('order/newOrder', { type: 'order' })
  }
}
</script>

<style scoped>
.purchase-order-container {
  flex: 1;
  display: flex;
  flex-flow: column;
  background-color: darkgray;
}
.purchase-order-loading {
  flex: 1;
  display: flex;
  flex-flow: column;
  background-color: white;
  justify-content: center;
  align-items: center;
}
.title {
  padding-left: 1rem;
  padding-bottom: .5rem;
  padding-top: 1rem;
  border-bottom: lightgray 1px solid;
  background-color: white;
}
.purchase-order {
  flex: 1;
  overflow: auto;
  padding: 1rem;
  background-color: white;
}
.level {
  border-top: lightgray 1px solid;
  padding: 1rem;
  background-color: white;
}
.button {
  margin-right: .5rem;
}
.items {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0;
  padding: 0 1rem;
}
@media only screen and (min-width: 1024px) {
  .purchase-order {
    position: relative;
    margin: auto;
    min-width: 64rem;
  }
}
</style>
